export const QUALIFICATION_INTRO_UNLOCK_MS = 15_000;

export function remainingUnlockSeconds({
  startedAtMs,
  nowMs,
  durationMs = QUALIFICATION_INTRO_UNLOCK_MS,
}: {
  readonly startedAtMs: number;
  readonly nowMs: number;
  readonly durationMs?: number;
}): number {
  return Math.max(0, Math.ceil((startedAtMs + durationMs - nowMs) / 1000));
}
